import BannerNavbar from "../components/Banner";

const HomePage = () => {
  return <BannerNavbar />;
};

export default HomePage;
